import { z } from 'zod';
import { expectType } from './model.js';
import { EmptyPostBase, zFullPostBase, zPostBase } from './post.js';
import { dateDiffDays, getNow } from './util/date.js';
export const zEventFields = z.object({
    postType: z.literal('event'),
    eventDate: z.string().datetime().or(z.literal('')),
    eventEndDate: z.string().datetime().or(z.literal('')),
    location: z.string()
});
export const zEvent = zPostBase.merge(zEventFields);
expectType({});
expectType({});
export const zFullEvent = zFullPostBase.merge(zEventFields);
expectType({});
expectType({});
export const EmptyEvent = {
    ...EmptyPostBase,
    postType: 'event',
    eventDate: '',
    eventEndDate: '',
    location: ''
};
/**
 * Return true if the event started less than a day ago, or in the future
 * @param { Event } event The event
 * @returns { boolean } True if the event is not expired
 */
export const eventNotExpired = (event) => {
    const daysUntil = dateDiffDays(getNow(), event.eventDate);
    return daysUntil > -1;
};
